import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const insertPatternMatching = createAsyncThunk('insertPatternMatching', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertPatternMatching`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updatePatternMatching = createAsyncThunk('updatePatternMatching', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updatePatternMatch`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchPatternMatchingReg = createAsyncThunk('fetchPatternMatchingReg', async (id) => {
    try {
        const endpoint = id ? `getPatternMatchingReg&pmId=${id}` : 'getPatternMatchingReg';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});



const patternMatchSlice = createSlice({
    name: 'PatternMatchData',
    initialState: {
        isLoading: false,
        patMat: null,
        isError: false
    },
    extraReducers: (builder) => {



        builder.addCase(fetchPatternMatchingReg.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPatternMatchingReg.fulfilled, (state, action) => {
            state.isLoading = false;
            state.patMat = action.payload;
        });
        builder.addCase(fetchPatternMatchingReg.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


    }
});

export default patternMatchSlice.reducer;
